// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 63 ? "ImportFuncDemo" : chunkId) + "." + {"63":"150f1c94","468":"4c2e1c9d"}[chunkId] + ".js";
};